<template functional>
    <div>
        <strong class="card-text">{{ parent.$t('externalIncentive.title') }}</strong>
        <p class="card-text">{{ parent.$t('externalIncentive.notice') }}</p>
        <div class="card-navigation">
            <a class="btn btn-primary" :href="props.link + props.queryParam + props.code" target="_blank">
                {{ parent.$t('externalIncentive.button') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExternalIncentiveBlock',
    functional: true,
    props: {
        code: String,
        link: {
            type: String,
            default: process.env.VUE_APP_EXTERNAL_INCENTIVE_URL
        },
        queryParam: {
            type: String,
            default: "?code="
        }
    },
}
</script>

<style scoped lang="scss">
    .card-navigation {
        padding-bottom: 1.25rem;
    }
</style>